import styles from './StatusMessage.module.css';
import type { ReactNode } from 'react';

interface StatusMessageProps {
  readonly tone?: 'info' | 'error';
  readonly children: ReactNode;
}

/** Full-width live region for loading and failure states. */
export function StatusMessage({ tone = 'info', children }: StatusMessageProps) {
  return (
    <p
      className={tone === 'error' ? styles['error'] : styles['info']}
      role={tone === 'error' ? 'alert' : 'status'}
    >
      {children}
    </p>
  );
}
